module.exports = __webpack_public_path__ + "img/panduan-belanja.5d2ffa62.jpg";